// extracted by mini-css-extract-plugin
module.exports = {"content":"Modal_content__Fchkl","contentWrapper":"Modal_contentWrapper__oBRfq","closeButton":"Modal_closeButton__Foob_"};